exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@keyframes Clouds__drift___3GuAw{0%{background-position:-100%}to{background-position:0}}.Clouds__clouds___ZqF3b{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;background-image:url(\"img/game/clouds.png\");background-size:cover;animation:Clouds__drift___3GuAw 180s infinite}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/map/Clouds.scss"],"names":[],"mappings":"AAAA,iCAAiB,GAAG,yBAAyB,CAAC,GAAK,qBAAqB,CAAC,CAAC,wBAAQ,kBAAkB,MAAM,OAAO,WAAW,YAAY,oBAAoB,4CAA4C,sBAAsB,6CAA6B,CAAC","file":"Clouds.scss","sourcesContent":["@keyframes drift{0%{background-position:-100%}100%{background-position:0}}.clouds{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;background-image:url(\"img/game/clouds.png\");background-size:cover;animation:drift 180s infinite}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"clouds": "Clouds__clouds___ZqF3b",
	"drift": "Clouds__drift___3GuAw"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib?{"modules":true,"importLoaders":1,"sourceMap":true,"localIdentName":"[name]__[local]___[hash:base64:5]","camelCase":true,"namedExport":true,"url":false}!./node_modules/sass-loader/lib/loader.js!./src/ts/app/screens/game/map/Clouds.scss
// module id = 195
// module chunks = 0